import React from 'react';
import { useTranslation } from 'react-i18next';
import HeaderWithStatus from '../../../../common/Headers/HeaderWithStatus/HeaderWithStatus';
// eslint-disable-next-line import/no-cycle
import { ExpenseHeaderConfig } from './ExpenseHeaderConfig';
import { useWindowSize } from '../../../../../utils/hooks';
import classes from './ExpenseHeader.module.scss';
import { responsiveSizeTimesheet } from '../../../../../utils/constants';
// eslint-disable-next-line import/no-cycle
import TimeandExpenseActions from '../../../../common/buttons/TimeandExpenseActions/TimeandExpenseActions';

export default function ExpenseHeader({
  error,
  expense,
  save,
  submit,
  approve,
  reject,
  withdraw,
  isRejectActive,
  saving,
  rejecting,
  isApprover,
  getFormData,
  placementStatus,
  placementHandler,
  hasChanges
}) {
  const { t } = useTranslation();
  const size = useWindowSize();
  const expenseHeaderConfig = ExpenseHeaderConfig(t, expense, size, classes, isApprover, getFormData);
  const { dataStatusLogic, headerLeft, keyValueLabels } = expenseHeaderConfig;

  const expenseActions = () => {
    return (
      size.width > responsiveSizeTimesheet && (
        <TimeandExpenseActions
          error={error}
          saving={saving}
          rejecting={rejecting}
          save={save}
          submit={submit}
          approve={approve}
          reject={reject}
          withdraw={withdraw}
          isRejectActive={isRejectActive}
          isApprover={isApprover}
          status={expense?.Status?.Status}
          placementStatus={placementStatus}
          placementHandler={placementHandler}
        />
      )
    );
  };
  return (
    <HeaderWithStatus
      data={expense}
      dataStatusLogic={dataStatusLogic}
      leftContent={headerLeft}
      keyValueLabel={keyValueLabels}
      actionsContainer={expenseActions()}
      isApprover={isApprover}
      hasChanges={hasChanges}
    />
  );
}
